import './index.scss';

import classNames from 'classnames';
import { type FC, memo, type ReactNode } from 'react';

import { useRightPanelContext } from '../../../context/right-section';
import type { IUsePanelHistory } from '../../../hooks/panel-history';
import { TypeButton } from '../button';
import TextPrompt from '../text-prompt';

export interface IRSection {
	children?: any;
	panelHistoryProps: IUsePanelHistory;
}

const RightPanel: FC<IRSection> = ({ children, panelHistoryProps }) => {
	const rightPanel = useRightPanelContext();

	const isTitleString = typeof rightPanel?.title === 'string';

	const closeRightSection = () => {
		panelHistoryProps?.reset();
		rightPanel?.closeSection?.();
	};

	// Improved ctaLoad logic
	const ctaLoad = rightPanel?.cta.reduce(
		(acc, { load, loadText, responseText, responseStatus }) => ({
			status: acc.status || !!load,
			text: loadText || acc.text,
			response: responseText || acc.response,
			responseStatus: responseStatus ?? acc.responseStatus,
		}),
		{ status: false, text: '', response: '', responseStatus: false }
	);

	return (
		<>
			<div
				className={`back-drop ${rightPanel?.openSection ? 'open' : 'close'}`}
				onClick={closeRightSection}
			/>

			<div
				className={classNames('right_container', {
					menuopen: rightPanel?.openSection,
					menuclose: !rightPanel?.openSection,
					max: rightPanel?.max,
				})}
			>
				<div className='rs-header border-label-bottom gap-20'>
					{/* <div className='mt-auto py-3 f-row-26'>
						<NavArrowLeftSVG
							aria-label='history navigation left'
							color={panelHistoryProps.canGoBack ? '' : 'lightgrey'}
							style={{
								cursor: panelHistoryProps.canGoBack ? 'default' : 'not-allowed',
							}}
							onClick={panelHistoryProps.goBack}
						/>

						<NavArrowRightSVG
							aria-label='history navigation right'
							color={panelHistoryProps.canGoForward ? '' : 'lightgrey'}
							style={{
								cursor: panelHistoryProps.canGoForward ? 'default' : 'not-allowed',
							}}
							onClick={panelHistoryProps.goForward}
						/>
					</div> */}

					<div className='border-label rounded p-2 w-100'>{isTitleString ? <h3>{rightPanel.title}</h3> : rightPanel?.title}</div>

					<div className='f-row-20 align-items-center ctas ml-auto'>
						<TypeButton
							title=''
							// close
							// buttonType='danger'
							// buttonSize='small'
							onClick={closeRightSection}
						/>
					</div>
				</div>

				{rightPanel?.title ? (
					<div className='rs-body position-relative'>
						<ChildComponents>{children}</ChildComponents>
						{rightPanel?.cta.length > 0 && (
							<div
								className='position-fixed bg-white border-label-top shadow w-100 py-3 justify-content-between align-items-center px-4'
								style={{ bottom: 0, left: 0, display: 'flex', zIndex: 50 }}
							>
								<div
									className='mx-auto f-row-17'
									style={{ width: '94%' }}
								>
									{rightPanel.cta.map((i, index) => (
										<div key={index}>
											{i.actionType !== 'multiple' ? (
												<TypeButton
													title={i.title}
													buttonType={ctaLoad?.status ? 'disabled' : i.buttonType}
													// buttonSize='small'
													onClick={i.action}
												/>
											) : (
												// <ActionComponent
												// 	title={i.title}
												// 	actions={i.actionOptions?.map(({ title, action }) => ({
												// 		label: title,
												// 		action,
												// 	}))}
												// 	buttonType={i.buttonType}
												// 	buttonSize='small'
												// />
												<></>
											)}
										</div>
									))}
								</div>

								<div style={{ flexShrink: 0 }}>
									{ctaLoad?.status ? (
										// <RefreshComponent
										// 	load={ctaLoad.status}
										// 	text={ctaLoad.text}
										// />
										<></>
									) : (
										<TextPrompt
											prompt={ctaLoad?.response}
											status={ctaLoad?.responseStatus}
										/>
									)}
								</div>
							</div>
						)}
					</div>
				) : (
					<div className='pt-3'>
						{!rightPanel?.data ? (
							<TextPrompt
								prompt='Something went wrong'
								status={false}
							/>
						) : (
							// <PulseSVG />
							<></>
						)}
					</div>
				)}
			</div>
		</>
	);
};

export default RightPanel;

interface IChildComponent extends React.HTMLAttributes<HTMLDivElement> {
	children: ReactNode;
}

export const ChildComponents: FC<IChildComponent> = memo(({ children, ...rest }) => <div {...rest}>{children}</div>);

ChildComponents.displayName = 'ChildComponents';
